import React, {useState} from "react";
import "./Prices.css";

const Prices = function (props) {
    const [showFreeEnter,setShowFreeEnter] = useState(false);
    const displayFreeEntrances = () => {
        setShowFreeEnter(!showFreeEnter);
    }

    return (       
        <React.Fragment>
            <div className="mainPriceEntrance">
                <h3>מחיר כניסה</h3>
                <ul className="itemsDisplay">{props.data.map((dat1) => {
                    if(!dat1.MODMuseumIsFree){ 
                        return (
                            <li className= "listItemCharge" key={dat1.ID}>
                                <div className="itemPriceTitle">
                                    <span className="itemTitle">{dat1.Title} </span>
                                </div>
                                <div className="itemPrice">
                                    <span>{dat1.MODPrice}</span>
                                    <i className="fas fa-shekel-sign"></i>
                                </div>
                            </li> 
                    )}})}</ul>

                <div className="freeEntranceDiv">
                    <div className="freeEntranceButton" onClick={displayFreeEntrances}>
                        <span>כניסה ללא תשלום (בהצגת תעודה)</span>
                        <i className="fas fa-sort-down"></i>
                    </div>
                    <div className={showFreeEnter ?"":"hide " +"freeItemsDiv"}>
                        <ul className="itemsDisplay">{props.data.map((dat2) => {
                            if(dat2.MODMuseumIsFree){ 
                                return (
                                    <li className= "listItemFree" key={dat2.ID}>
                                        <span className="itemTitle">{dat2.Title} </span>
                                    </li>         
                            )}})}
                        </ul>
                    </div>
                </div>
            </div>

        </React.Fragment>
    );
}

export default Prices;